import * as React from 'react';
import { JRCTypographyProps } from './JRCTypography.d';
import { Typography } from './JRCTypography.styles';

export const JRCTypography = ({ variant, ...props }: JRCTypographyProps) => <Typography as={variant} {...props} />;
